<template>
    <rkm-layout-body title="Geração / Lançamento de procedimento individualizado">
        <template v-slot:actions>
            <rkm-button
                @click="$refs.ModalGeracao.open()"
                authorize="store-bpa-procedimento-individualizado"
                color="primary"
            >
                Gerar
            </rkm-button>

            <rkm-button
                @click="$router.push('/bpa/procedimento-individualizado/create')"
                authorize="store-bpa-procedimento-individualizado"
                color="primary"
            >
                Cadastrar procedimento
            </rkm-button>

            <rkm-button
                @click="$refs.ModalExclusao.open()"
                authorize="destroy-bpa-procedimento-individualizado"
                color="danger"
            >
                Excluir BPA
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List ref="List" />
        </rkm-layout-content>

        <ModalExclusao
            ref="ModalExclusao"
            @save="$refs.List.refresh()"
        />
        <ModalGeracao
            ref="ModalGeracao"
            @save="$refs.List.refresh()"
        />
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/bpa/procedimento-individualizado/List'
import ModalExclusao from '@/components/bpa/procedimento-individualizado/components/exclusao/Modal'
import ModalGeracao from '@/components/bpa/procedimento-individualizado/components/geracao/Modal'

export default {
    components: {
        List,
        ModalExclusao,
        ModalGeracao,
    },
}
</script>